import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSlash, faExclamationTriangle, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import { StandardURL } from "../App";


const DeleteCaretaker = () => {
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    if (confirmation) {
      // Retrieve the selected caretaker id from local storage
      const selectedCaretakerId = localStorage.getItem("selectedCaretakerId");

      // Retrieve the propertyId from local storage
      const propertyId = localStorage.getItem("selectedPropertyId");
      const token = localStorage.getItem("token");

      // Construct the delete URL
      const deleteURL = `${StandardURL}/iNyumba/users/caretaker/${propertyId}/${selectedCaretakerId}/delete`;

      // Send DELETE request to the backend API
      axios
        .delete(deleteURL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          // Once deletion is successful, clear the selected caretaker id from local storage
          localStorage.removeItem("selectedCaretakerId");

          toast.success(response.data.response);

          // Navigate back to the caretakers page
          navigate(-1);
        })
        .catch((error) => {
          console.error("Error deleting caretaker:", error);
          toast.error(error.response.data.response);
        });
    }
  }, [confirmation, navigate]);

  const handleDelete = () => {
    setConfirmation(true);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-red-100 to-red-200 flex items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl border border-red-300 text-center transform transition-all duration-300 scale-95 hover:scale-100">
            {/* --- Header & Icon --- */}
            <div className="mb-6">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 text-6xl mb-4 animate-bounce-slow" />
              <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Confirm Caretaker Deletion</h1>
            </div>

            {/* --- Confirmation Message --- */}
            <p className="text-lg text-gray-700 mb-8 leading-relaxed font-medium">
              Are you **absolutely sure** you want to delete this caretaker?
              <br />
              This action is **irreversible** and will permanently remove their record.
            </p>

            {/* --- Action Buttons --- */}
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button
                onClick={handleDelete}
                className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-semibold rounded-lg shadow-md text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 transition duration-300 ease-in-out transform hover:scale-105"
              >
                <FontAwesomeIcon icon={faUserSlash} className="mr-3 text-white text-xl" />
                Yes, Delete Caretaker
              </button>

              <button
                onClick={handleCancel}
                className="inline-flex items-center justify-center px-8 py-4 border border-gray-300 text-lg font-semibold rounded-lg shadow-md text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition duration-300 ease-in-out transform hover:scale-105"
              >
                <FontAwesomeIcon icon={faTimes} className="mr-3 text-gray-600 text-xl" />
                No, Keep Caretaker
              </button>
            </div>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default DeleteCaretaker;
